export const getMaxColumnsFromHtml = (html: string): number => {
  const tableBlocks = html.match(/<table\b.*?<\/table>/gis) ?? [];
  let maxColumns = 1;

  for (const table of tableBlocks) {
    const rows = table.match(/<tr\b.*?<\/tr>/gis) ?? [];
    for (const row of rows) {
      const cells = row.match(/<(th|td)\b[^>]*>/gi) ?? [];
      let rowColumns = 0;

      for (const cell of cells) {
        const colspanMatch = /\bcolspan\s*=\s*["']?(\d+)["']?/i.exec(cell);
        const colspan = Number(colspanMatch?.[1] ?? 1);
        rowColumns += Number.isFinite(colspan) && colspan > 0 ? colspan : 1;
      }

      maxColumns = Math.max(maxColumns, rowColumns);
    }
  }

  return maxColumns;
};

const MAGNOLIA_IMAGE_SOURCE_PATTERN =
  /src="\$\{link:\{([^}]|\}(?!"))*?path:\{([^}]*)\}([^}]|\}(?!"))*?\}"/g;

export const replaceMagnoliaImageSourceObject = ({
  html,
  imageBase,
}: {
  html: string;
  imageBase: string;
}) =>
  html.replaceAll(
    MAGNOLIA_IMAGE_SOURCE_PATTERN,
    (_, __, path: string) => `src="${imageBase}${path}"`,
  );
